module.exports = require('../impls/$append/async-append.js').__asyncAppend;